/* CRAZY MUG — compléments : upgrade de pack dans le panier, prix unitaire sous le prix. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const rafraichir = async () => {
    const panier = $('[data-sy-panier]');
    if (!panier) return;
    const corps = $('[data-sy-corps]', panier);
    const r = await fetch(racine + '?section_id=somya-panier-contenu', { headers: { Accept: 'text/html' } });
    if (!r.ok) return;
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const neuf = $('[data-sy-contenu]', doc);
    if (neuf && corps) { corps.innerHTML = ''; corps.appendChild(neuf); const n = Number(neuf.dataset.syNombre || 0); $$('[data-sy-compteur]').forEach((el) => { el.textContent = n; el.hidden = !n; }); }
  };

  /* Passer à un pack supérieur en un clic : on retire la ligne, on ajoute la variante du pack. */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cm-upgrade]');
    if (!b) return;
    const zone = b.closest('[data-sy-panier], [data-sy-panier-page]');
    zone && zone.classList.add('est-charge');
    b.disabled = true; b.textContent = (window.cmStrings || {}).instant || 'Un instant…';
    try {
      await fetch(racine + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.cmKey, quantity: 0 }) });
      await fetch(racine + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.cmUpgrade), quantity: 1 }] }) });
    } catch (_) {}
    if (zone && zone.hasAttribute('data-sy-panier-page')) { location.reload(); return; }
    await rafraichir();
    zone && zone.classList.remove('est-charge');
  });

  /* Upsell panier : ajout en un clic d'un produit complémentaire (1er pack), puis rafraîchissement. */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cm-add]');
    if (!b) return;
    const zone = b.closest('[data-sy-panier], [data-sy-panier-page]');
    const label = b.querySelector('span') || b;
    b.disabled = true; label.textContent = (window.cmStrings || {}).ajout || 'Ajout…';
    zone && zone.classList.add('est-charge');
    try {
      const r = await fetch(racine + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.cmAdd), quantity: 1 }] }) });
      if (!r.ok) throw new Error('add');
      label.textContent = (window.cmStrings || {}).ajoute || 'Ajouté ✓';
    } catch (_) { label.textContent = (window.cmStrings || {}).reessayez || 'Réessayez'; b.disabled = false; zone && zone.classList.remove('est-charge'); return; }
    if (zone && zone.hasAttribute('data-sy-panier-page')) { location.reload(); return; }
    await rafraichir();
    zone && zone.classList.remove('est-charge');
  });

  /* Prix par verre + économie sous le prix principal quand on change de pack. */
  const pp = $('[data-sy-produit]');
  if (pp) {
    const unit = $('[data-cm-unit]', pp), eco = $('[data-cm-eco]', pp), stickyTxt = $('[data-cm-sticky-pack]');
    const maj = () => {
      const c = $('[data-sy-valeur]:checked', pp);
      if (!c) return;
      if (unit) unit.innerHTML = c.dataset.cmUnitTxt || '';
      if (eco) { eco.textContent = c.dataset.cmEcoTxt || ''; eco.hidden = !c.dataset.cmEcoTxt; }
      if (stickyTxt) stickyTxt.textContent = c.value;
    };
    pp.addEventListener('change', (e) => { if (e.target.matches('[data-sy-valeur]')) maj(); });
    maj();
  }

  /* Aperçu rapide (mini-fiche) des produits upsell du panier. */
  let qv = null;
  const ouvrirQv = (h, origine) => {
    const tpl = document.querySelector('template[data-cm-qv-tpl="' + h + '"]');
    if (!tpl) return false;
    if (!qv) {
      qv = document.createElement('dialog'); qv.className = 'cm-qv';
      qv.innerHTML = '<button type="button" class="cm-qv__fermer" aria-label="Fermer" data-cm-qv-fermer>&times;</button><div class="cm-qv__inner" data-cm-qv-inner></div>';
      document.body.appendChild(qv);
      qv.addEventListener('click', (e) => { if (e.target === qv || e.target.closest('[data-cm-qv-fermer]')) qv.close(); });
    }
    const inner = qv.querySelector('[data-cm-qv-inner]');
    inner.innerHTML = ''; inner.appendChild(tpl.content.cloneNode(true));
    qv.showModal();
    return true;
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-cm-qv]');
    if (!a) return;
    if (ouvrirQv(a.dataset.cmQv, a)) e.preventDefault();
  });
  document.addEventListener('click', (e) => { if (qv && qv.open && e.target.closest('[data-cm-add]') && qv.contains(e.target)) setTimeout(() => qv.close(), 700); });

  /* Urgence honnête : commandé avant l'heure limite (heure de Paris) → expédié aujourd'hui. */
  $$('[data-cm-urgence]').forEach((el) => {
    const limite = Number(el.dataset.cmUrgence || 20);
    const txt = $('[data-cm-urgence-txt]', el), reste = $('[data-cm-urgence-reste]', el);
    const maj = () => {
      const now = new Date();
      const paris = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      const jour = paris.getDay();
      let cible = new Date(paris); cible.setHours(limite, 0, 0, 0);
      const ouvert = jour >= 1 && jour <= 5;
      if (ouvert && paris < cible) {
        const diff = cible - paris, h = Math.floor(diff / 36e5), m = Math.floor((diff % 36e5) / 6e4);
        el.classList.add('est-ouvert');
        if (txt) txt.textContent = el.dataset.cmAvant.replace('{heure}', limite);
        if (reste) reste.textContent = el.dataset.cmReste.replace('{temps}', (h ? h + ' h ' : '') + String(m).padStart(2, '0') + ' min');
      } else {
        el.classList.remove('est-ouvert');
        if (txt) txt.textContent = ouvert ? el.dataset.cmApres : (el.dataset.cmWeekend || el.dataset.cmApres);
        if (reste) reste.textContent = '';
      }
    };
    maj(); setInterval(maj, 30000);
  });
})();
